import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getIn } from 'seamless-immutable';
import { Stars } from '@catalogo/theme-stars';

export const Rating = ({ rating, size, productId, fontSize = 14, dispatchMetrics }) => {
  const ratingAverage = rating?.average;
  const average = ratingAverage?.toString()?.indexOf('.') > -1 ? ratingAverage : `${ratingAverage}.0`;
  const metricFirstReview = () =>
    dispatchMetrics('event:track', {
      category: 'avaliacao-pdp',
      action: 'primeira-avaliacao',
    });
  const metricReviews = () =>
    dispatchMetrics('event:track', {
      category: 'avaliacao-pdp',
      action: 'link-avaliacoes',
    });

  if (!rating?.reviews) {
    const reviewForm = `/avaliacao/${productId}`;
    return (
      <>
        <Stars rating={getIn(rating, ['average'], 0)} size={size} />
        <Link href={reviewForm} fontSize={fontSize} onClick={metricFirstReview}>
          Faça a 1ª avaliação
        </Link>
      </>
    );
  }

  return (
    <a href="#card-reviews-title" onClick={metricReviews}>
      <Container>
        <Stars rating={getIn(rating, ['average'], 0)} size={size} />
        <RatingAverageStyle fontSize={fontSize}>{average}</RatingAverageStyle>
        {getIn(rating, ['reviews'], false) && (
          <Count fontSize={fontSize}>({`${rating?.reviews} avaliaç${rating?.reviews > 1 ? 'ões' : 'ão'}`})</Count>
        )}
      </Container>
    </a>
  );
};

Rating.defaultProps = {
  size: 22,
};

Rating.propTypes = {
  rating: PropTypes.object,
  id: PropTypes.number,
};

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const Count = styled.span`
  font-size: ${({ fontSize }) => fontSize}px;
  color: #717171;
  text-decoration: underline;
  margin-left: 3px;
  text-transform: ${({ theme }) => theme.titleTransform};
  &:hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;

const RatingAverageStyle = styled.span`
  color: #575757;
  font-weight: bold;
  font-size: ${({ fontSize }) => fontSize}px;
  padding-top: 1px;
  margin: 0 3px;
`;

const Link = styled.a`
  text-decoration: underline;
  color: #717171;
  font-size: ${({ fontSize }) => fontSize}px;
  display: flex;
  align-items: center;
  margin-left: 5px;
  text-transform: ${({ theme }) => theme.titleTransform};
  &:hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;
